<template>
    <div>
        <a href="#"
           class="btn-annotation"
           :style="data.styleRect"
           @click.prevent="toggleCurrentRoleActive"
        >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed}  from "vue";
    import cssvar from '@/scss/_variables.scss';
    import {usePaging} from "@/modules/reader/book/paging";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";

    const colorRect = cssvar.colorRect;
    const {pageResizeState} = usePageResize();
    const {getResizedAnnotationPos} = useAnnotationHelper();
    const {muteRoleState, toggleActiveRole,  isInActiveMuteRoles, muteCurrentAudio, unmuteCurrentAudio} = useMuteRoleControl();

    export default {
        props: {
            annot:Object,
            pagenum:Number
        },
        setup(props, context) {

            const { bookData } = useDataLoader();
            const { setCurrentPage} = usePaging();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        background: (data.isActive) ? "rgba(255,204,201, .6)" : "transparent",
                        position:"absolute"
                    }
                }),
                isActive:computed(()=>{
                    return isInActiveMuteRoles(props.pagenum,  props.annot.roleId)
                })
            });

            const toggleCurrentRoleActive = ()=> {
                //console.log("toggleCurrentRoleActive muteRole page ranges:");
                //console.log(muteRoleState.pageRanges);
                toggleActiveRole(props.pagenum, props.annot.roleId);
            }


            return {
                data,
                props,
                setCurrentPage,
                toggleActiveRole,
                toggleCurrentRoleActive,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped>

</style>